import { render } from "./DGroup.vue?vue&type=template&id=6fb9459e&scoped=true"
import script from "./DGroup.vue?vue&type=script&lang=ts"
export * from "./DGroup.vue?vue&type=script&lang=ts"

import "./DGroup.vue?vue&type=style&index=0&id=6fb9459e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fb9459e"

export default script